export default function getTextWidth(text) {
  if (typeof window !== "undefined") {
    const element = document.createElement("canvas");
    const context = element.getContext("2d");
    context.font = "16px Arial";
    return context.measureText(text).width;
  }
}
